import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizardStepState } from '../../../../shared/services/sage-wizard.model';

@Component({
  selector: 'app-wizard-stepper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './wizard-stepper.component.html',
  styleUrls: ['./wizard-stepper.component.css'],
})
export class WizardStepperComponent {
  @Input() labels: string[] = [];
  @Input() states: WizardStepState[] = [];
  @Input() current = 0;

  isDone(index: number): boolean {
    return index !== this.current && (this.states[index] === 'done' || this.states[index] === 'sent');
  }

  get percent(): number {
    return this.labels.length ? ((this.current + 1) / this.labels.length) * 100 : 0;
  }
}
